import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "i18next";
import { useGetListDocument } from "hooks/useDocument";
import {
  Box,
  Button,
  Flex,
  Text,
  Spinner,
  Spacer,
  useColorModeValue,
} from "@chakra-ui/react/dist/chakra-ui-react.cjs";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import UploadFile from "components/UploadFile";
import { useForm } from "react-hook-form";
import { useImportCsv } from "hooks/useDocument";
import { CSV_EXTENSION } from "constants";
import GreenButton from "components/Buttons/GreenButton";
import ModalDeleteDocument from "../../components/modals/ModalDeleteDocument";
import { useModalState } from "../../hooks/useModalState";
import { useDeleteDocument } from "../../hooks/useDocument";
import DocumentsTable from "components/Documents/DocumentsTable";
import DocumentFilter from "components/Documents/DocumentFilter";
import Pagination from "components/Pagination/Pagination";

const DocumentList = () => {
  const history = useHistory();
  const [searchName, setSearchName] = useState("");
  const [fiscalYearJp, setFiscalYearJp] = useState("");
  const [params, setParams] = useState({
    page: 1,
    limit: 15,
    filter: "",
    sortType: -1,
    sort: "id",
    fiscal_year_jp: "",
  });

  const { data, isLoading, error } = useGetListDocument(params);
  const tableData = data?.result?.data;
  const total = data?.result?.meta?.total;

  const mutationUploadCsv = useImportCsv();
  const mutationDeleteDocument = useDeleteDocument();

  const [currentId, setCurrentId] = useState();
  const [selectedDocumentCode, setSelectedDocumentCode] = useState();

  const methods = useForm({
    defaultValues: {
      file: null,
    },
  });
  const { modalState, open, close, closeAll } = useModalState({
    modalDeleteDocument: false,
  });
  const onSubmitDelete = (id) => {
    mutationDeleteDocument.mutate(id);
    close("modalDeleteDocument");
  };

  const search = () => {
    setParams((prevState) => {
      const tempData = { ...prevState };
      tempData.filter = searchName;
      tempData.fiscal_year_jp = fiscalYearJp;
      tempData.page = 1;
      return tempData;
    });
  };

  const changeSort = (typeParams) => {
    setParams((prevState) => {
      const tempData = { ...prevState };
      tempData.sortType = typeParams;
      tempData.sort = "name";
      return tempData;
    });
  };

  const onSubmit = (data) => {
    const ext = data.file[0].name.split(".").pop().toLowerCase();
    if (ext !== CSV_EXTENSION) {
      methods.setError("file", {
        type: "manual",
        message: t("pages.document.list.upload_csv.error"),
      });
    } else {
      const formData = new FormData();
      formData.append("file", data.file[0]);
      mutationUploadCsv.mutate(formData);
    }
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "40px" }}>
      <Card>
        <CardHeader p="6px 0px 40px 0px">
          <Box justifyContent={"space-between"}>
            <Text fontSize="xl" fontWeight="bold">
              {t("pages.document.list.title")}
            </Text>
          </Box>
          <Flex align="end">
            <Box w="80%">
              <DocumentFilter
                onSearch={search}
                searchName={searchName}
                setSearchName={setSearchName}
                fiscalYearJp={fiscalYearJp}
                setFiscalYearJp={setFiscalYearJp}
              />
            </Box>
            <Spacer />
            <Box w="20%" flex="1" textAlign="right" pr="8.5%" mb="4px">
              <Button
                onClick={() => history.push(`/admin/documents/create`)}
                color="white"
                background="#007bff"
                fontSize="14px"
                _hover={{ background: "#007bff99" }}
                size={"sm"}
              >
                {t("pages.document.list.create_new")}
              </Button>
            </Box>
          </Flex>
          <Box w={"100%"} justifyContent={"space-between"} maxWidth={"800px"}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Flex>
                <Box w={"50%"} display={"flex"} mt={"20px"}>
                  <UploadFile
                    name="file"
                    control={methods.control}
                    formMethods={methods}
                    textBtn={t("pages.document.list.select_csv")}
                    accept={".csv"}
                  />
                </Box>
                <Box w={"50%"} display={"flex"} mt={"20px"}>
                  <GreenButton
                    type="submit"
                    text={t("pages.document.list.import")}
                  />
                </Box>
              </Flex>
            </form>
          </Box>
        </CardHeader>
        <CardBody>
          <DocumentsTable
            listDocument={tableData}
            params={params}
            changeSort={changeSort}
            onRequestDelete={(item) => {
              open("modalDeleteDocument");
              setCurrentId(item.id);
              setSelectedDocumentCode(item.course_code);
            }}
            onRequestDetail={(item) =>
              history.push(`/admin/documents/edit/${item.id}`)
            }
          />
          {isLoading && (
            <Box textAlign="center" mt="40px">
              <Spinner></Spinner>
            </Box>
          )}
          {total && Math.ceil(total / params.limit) > 1 ? (
            <Pagination
              total={total}
              perPage={params.limit}
              currentPage={params.page}
              setParams={setParams}
            />
          ) : null}
          {error && (
            <Box textAlign="center" pt="20px" color="gray.400" fontSize="14px">
              {t("messages.common_s005")}
            </Box>
          )}
        </CardBody>
      </Card>
      <ModalDeleteDocument
        isOpen={modalState.modalDeleteDocument}
        content={`コースID ${selectedDocumentCode} ${t(
          "pages.document.list.table.confirm_delete"
        )}`}
        onClose={() => close("modalDeleteDocument")}
        onSubmit={() => onSubmitDelete(currentId)}
      />
    </Flex>
  );
};

export default DocumentList;
